import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Col, Nav, Row, Spinner } from 'react-bootstrap'
import { Link, Route, Switch } from 'react-router-dom'

import Welcome from './Welcome'
import Security from './Security'
import TeamMembers from './TeamMembers'
import LandingPage from './LandingPage'
import LicensedTeam from './LicensedTeam'
import LocationTeam from './LocationTeam'
import UserDetailsCard from '../_Components/UserDetailsCard'
import InactivateModal from '../_Components/InactivateModal'

import { alertActions } from '../../../../_actions/alert.actions'
import { usersService } from '../../../../_services/users.service'

import './style.css'
import ActivateModal from '../List/_Components/ActivateModal'

export default function ViewUser({ history, match }) {
  const dispatch = useDispatch()

  const [user, setUser] = useState({})
  const [activeTab, setActiveTab] = useState('security')

  const [showInactivateModal, setShowInactivateModal] = useState(false)
  const [showActivateModal, setActivateModal] = useState(false)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (history.location.pathname.indexOf('landing') !== -1) {
      setActiveTab('landing')
    } else if (history.location.pathname.indexOf('team-members') !== -1) {
      setActiveTab('team')
    } else if (history.location.pathname.indexOf('licensed-teams') !== -1) {
      setActiveTab('licensed')
    } else if (history.location.pathname.indexOf('location-teams') !== -1) {
      setActiveTab('location')
    } else {
      setActiveTab('security')
    }
  })

  useEffect(() => {
    usersService.getUser(match.params.id)
    .then(data => {
      setUser(data)
    })
    .catch(() => {
      history.push('/account/users')

      dispatch(alertActions.error('Could not retreive the user at this time. Please try again.'))
    })
  }, [dispatch, history, match.params.id])

  const reloadUser = () => {
    usersService.getUser(user.userId)
      .then(data => {
        setUser(data)
      })
      .catch(() => {
        history.push('/account/users')

        dispatch(alertActions.error('Could not retreive the user at this time. Please try again.'))
      })
  }

  const handleEdit = () => {
    history.push('/account/users/edit', { user })
  }

  if (Object.keys(user).length === 0) {
    return <Spinner animation='border'/>
  }

  return (
    <Fragment>
      <ActivateModal 
        user={user}
        show={showActivateModal}
        handleClose={(reload) => {
          setActivateModal(false)

          if (reload) {
            reloadUser()
          }
        }}
      />

      <InactivateModal
        user={user} 
        show={showInactivateModal}
        handleClose={(reload) => {
          setShowInactivateModal(false)

          if (reload) {
            reloadUser()
          }
        }}
      />

      <Row>
        <Col xs='3'>
          {user && 
            <UserDetailsCard user={user}>
              { user.userType === 'Staff' && 
                <>
                  <Row className='mt-4'>
                    <Col>
                      Public Identity:
                    </Col>
                  </Row>
                  <Row>
                    <Col className='text-muted font-weight-light'>
                      {`${user.publicIdentity ? 'Display' : 'Hide'} Identity`}
                    </Col>
                  </Row>
                </>
              }
              <Row className='mt-4'>
                <Col>
                  <Button onClick={handleEdit} block variant='success'>Edit</Button>
                </Col>

                { user.status !== 'Inactive' && <>
                  <Col>
                    <Button onClick={() => setShowInactivateModal(true)} block variant='outline-danger'>Inactivate</Button>
                  </Col>
                </> }

                { user.status === 'Inactive' && <>
                  <Col>
                    <Button onClick={() => { setActivateModal(true)}} block variant='outline-primary'>Activate</Button>
                  </Col>
                </> }

              </Row>
            </UserDetailsCard>
          }
        </Col>
        <Col>
          <Row className='h-100'>
            <Col className='d-flex flex-column justify-content-between'>
              <Row className='mb-4'>
                <Col>
                  <Nav activeKey={activeTab} id='user-manage-nav' variant="pills" className="flex-row justify-content-start">
                    <Nav.Item>
                      <Nav.Link as={Link} to={`${match.url}/security`} eventKey="security">
                        <small><i className="fas fa-lock fa-sm"></i></small>&nbsp; Security
                      </Nav.Link>
                    </Nav.Item>
                    { 
                      user.userType === 'Licensed' ? <>
                        <Nav.Item>
                          <Nav.Link as={Link} to={`${match.url}/team-members`} eventKey="team">
                            <small><i className="fas fa-user-friends"></i></small>&nbsp; Team Members
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link as={Link} to={`${match.url}/landing`} eventKey="landing">
                            <small><i className="fas fa-bullhorn fa-sm"></i></small>&nbsp; Landing Page
                          </Nav.Link>
                        </Nav.Item>
                      </> 
                      :
                      <Nav.Item>
                        <Nav.Link as={Link} to={`${match.url}/licensed-teams`} eventKey="licensed">
                          <small><i className="fas fa-user-md fa-sm"></i></small>&nbsp; Licensed Team
                        </Nav.Link>
                      </Nav.Item>
                    }
                  </Nav>
                </Col>
              </Row>
              <Row className='h-100'>
                <Col xs={12}>
                  <Switch>
                    <Route path={`${match.path}/welcome`}>
                      <Welcome user={user} history={history} match={match} />
                    </Route>
                    <Route path={`${match.path}/team-members`}>
                      <TeamMembers user={user} />
                    </Route>
                    <Route path={`${match.path}/landing`}>
                      <LandingPage user={user} />
                    </Route>
                    <Route path={`${match.path}/licensed-teams`}>
                      <LicensedTeam user={user} />
                    </Route>
                    <Route path={`${match.path}`}>
                      <Security user={user} history={history} match={match} />
                    </Route>


                    <Route path={`${match.path}/location-teams`} component={LocationTeam} />

                  </Switch>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Fragment>
  )
}
